
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est son efficacité?`}</em></p>
    <p>{`Selon l’OMS, elle est de
`}<a parentName="p" {...{
        "href": "https://www.who.int/fr/news-room/feature-stories/detail/the-j-j-covid-19-vaccine-what-you-need-to-know"
      }}>{`85,4% contre les formes graves de la maladie et l’hospitalisation`}</a>{`,
vingt-huit jours après l’injection. Et de 66,9% contre une infection
symptomatique modérée ou grave. “Ces résultats sont un peu moins bons que ceux
des vaccins à ARNm, précise Blaise Genton, responsable médical des campagnes de
vaccination du canton de Vaud. Mais cela reste tout à fait efficace.” Selon
l’OFSP, la protection complète est atteinte trois semaines après l’injection
unique.`}</p>
    <p>{`Des chercheurs des Centres américains de prévention et de lutte contre les
maladies (CDC) ont publié le 24 septembre
`}<a parentName="p" {...{
        "href": "https://www.cdc.gov/mmwr/volumes/70/wr/mm7038e1.htm"
      }}>{`une étude`}</a>{` après avoir
analysé un échantillon de près de 3700 adultes hospitalisés entre le 11 mars et
le 15 août 2021 en raison du Covid (avec des symptômes graves). Durant cette
période, le vaccin de Moderna s'est révélé efficace à 93% pour prévenir les
hospitalisations, contre 88% pour celui de Pfizer et 71% pour celui de
Johnson&Johnson.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;